module.exports = __webpack_public_path__ + "media/customer_tickets/return-9e83a951.svg";